/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  GetUniversityQueryResponse,
  GetUniversityPathParams,
  GetUniversity404,
} from '../../types/GetUniversity'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getUniversity } from '../../clients/getUniversity'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getUniversityQueryKey = ({
  university_id,
}: {
  university_id: GetUniversityPathParams['university_id']
}) =>
  [
    {
      url: '/api/v1/universities/:university_id/',
      params: { university_id: university_id },
    },
  ] as const

export type GetUniversityQueryKey = ReturnType<typeof getUniversityQueryKey>

export function getUniversityQueryOptions(
  {
    university_id,
  }: { university_id: GetUniversityPathParams['university_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getUniversityQueryKey({ university_id })
  return queryOptions<
    GetUniversityQueryResponse,
    ResponseErrorConfig<GetUniversity404>,
    GetUniversityQueryResponse,
    typeof queryKey
  >({
    enabled: !!university_id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getUniversity(
        { university_id: university_id },
        { ...config, signal: config.signal ?? signal }
      )
    },
  })
}

/**
 * @summary Get university detail
 * {@link /api/v1/universities/:university_id/}
 */
export function useGetUniversity<
  TData = GetUniversityQueryResponse,
  TQueryData = GetUniversityQueryResponse,
  TQueryKey extends QueryKey = GetUniversityQueryKey,
>(
  {
    university_id,
  }: { university_id: GetUniversityPathParams['university_id'] },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetUniversityQueryResponse,
        ResponseErrorConfig<GetUniversity404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? getUniversityQueryKey({ university_id })

  const query = useQuery(
    {
      ...getUniversityQueryOptions({ university_id }, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetUniversity404>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
